import { defineComponent as e, createBlock as o, openBlock as n, withCtx as r, createTextVNode as c } from "vue";
import _ from "../../components/ViewLayout/ViewLayoutSection.vue.js";
const a = /* @__PURE__ */ e({
  __name: "CollectionSync",
  setup(i) {
    return (l, t) => (n(), o(_, null, {
      title: r(() => t[0] || (t[0] = [
        c("Sync")
      ])),
      _: 1
    }));
  }
});
export {
  a as default
};
